module.exports = __webpack_public_path__ + "assets/images/project/search-icon.svg?v=3cfb57e5";